import mapboxgl from "mapbox-gl";
import { renderToString } from "react-dom/server";
import { Dispatch, MutableRefObject } from "react";
import { IWellWaterSystemWCoordinates } from "../../../../../types";
import { Theme } from "@mui/material";
import { getViolationColor } from "../../../../../utils/waterSystemHelper";
import { UtilityDetailActions } from "../../../../../store/utilityDetails";
import { WaterSystemsActions } from "../../../../../store/waterSystems";
import { PublicMarkerPinIcon } from "../../../../icons/PublicMarkerPinIcon";

export const addMarkers = (
  mapRef: React.RefObject<mapboxgl.Map>, 
  coordinates: IWellWaterSystemWCoordinates[],
  markersRef: MutableRefObject<mapboxgl.Marker[]>, 
  theme: Theme,
/*  setPopupPosition: (position: { x: number; y: number } | null) => void,
  setPopupDetails: (details: any) => void,
  setFillColor: (fillColor: string) => void,*/
  dispatch: Dispatch<any>,
): void => {
  const map = mapRef.current;
  if (!map) {
    console.warn("Map reference is not initialized.");
    return;
  }

  removeMarkers(markersRef);

  coordinates.forEach((coordinate: IWellWaterSystemWCoordinates) => {
    const { GEOID_Blk, GEO_BLOCK, HU_2020 } = coordinate
    if (GEOID_Blk) {
      const { INTPTLAT, INTPTLON } = GEO_BLOCK;

      const color = getViolationColor(HU_2020, theme);
  
      const customMarkerHtml = renderToString(
        <PublicMarkerPinIcon fillColor={color} />
    );

      const customMarkerElement = document.createElement("div");
      customMarkerElement.innerHTML = customMarkerHtml;
      customMarkerElement.style.width = "24px";
      customMarkerElement.style.height = "24px";
      customMarkerElement.style.cursor = "pointer";

      /*customMarkerElement.addEventListener('mouseenter', () => {
        const markerPosition = map.project([Number(INTPTLON), Number(INTPTLAT)]);
        setPopupPosition({ x: markerPosition.x, y: markerPosition.y + 20 });
        setPopupDetails(coordinate);
        setFillColor(color);
      });*/

      customMarkerElement.addEventListener('mouseleave', () => {
/*        setPopupPosition(null);
        setPopupDetails(null);*/
      });

      customMarkerElement.addEventListener("click", (e) => {
           e.stopPropagation();
           dispatch(UtilityDetailActions.toggleDrawer());
           dispatch(UtilityDetailActions.setSelectedWellData(coordinates));
           dispatch(WaterSystemsActions.setSelectedWaterSystem(GEOID_Blk))
      });

      const marker = new mapboxgl.Marker({ element: customMarkerElement })
        .setLngLat([Number(INTPTLON), Number(INTPTLAT)])
        .addTo(map);

      markersRef.current.push(marker);
    }
  });
};

  export const removeMarkers = (markersRef) => {
    if (Array.isArray(markersRef.current)) {
      markersRef.current.forEach((marker) => marker.remove());
      markersRef.current = [];
    }
  };